export default __webpack_public_path__ + "static/media/triobanner.f31f49fd.png";